var scope_0 = require('/opt/build/repo/node_modules/mdx-deck/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d98c9c552bb63b245701e489ef798893.js').default;export default
        Object.assign({}, scope_0 )
    